<header class="dialog-header">
    <h3 class="header-heading">{{ 'dialogs.cardDeleteErrorDialog.header' | translate }}</h3>
    <button mat-icon-button class="close-button" (click)="closeDialog()">
        <span class="icon-close"></span>
    </button>
</header>


<div class="dialog-content">
    <div class="icon">
        <span class="icon-warning"></span>
    </div>
    <p [innerHTML]="'dialogs.cardDeleteErrorDialog.cardCannotBeDeleted' | translate: { cardName: targetCard, userName: data.userName }"></p>
    <ul>
        <li *ngFor="let req of data.cardRequirements">{{  'dialogs.cardDeleteErrorDialog.card' | translate: { cardName: req } }}</li>
        <li *ngFor="let req of data.subscriptionRequirements">{{ 'dialogs.cardDeleteErrorDialog.subscription' | translate: { subscriptionName: req } }}</li>
    </ul>
    <p>{{ 'dialogs.cardDeleteErrorDialog.toDeleteInstruction' | translate: { cardName: targetCard } }}</p>
</div>

<footer class="dialog-footer">
    <button (click)="closeDialog()" class="bciti-button bciti-button--blue">
        {{ 'common.close' | translate }}
    </button>
</footer>